import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {BillingPartyMember} from '../../../graphql/billing_party.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    billingPartyMembers: BillingPartyMember[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    selectedBillingPartyMember?: BillingPartyMember,
    setSelectedBillingPartyMember?: (member: BillingPartyMember) => void,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedBillingPartyMember, setSelectedBillingPartyMember, billingPartyMembers, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title={'Billing Party Members'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: 100}}>Id</TableCell>
                                        <TableCell>Name (Email)</TableCell>
                                        <TableCell>Tour</TableCell>
                                        <TableCell>Group</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {billingPartyMembers.map(member => {
                                        return (
                                            <TableRow
                                                hover
                                                key={member.id}
                                                selected={selectedBillingPartyMember === member}
                                                onClick={() => setSelectedBillingPartyMember ? setSelectedBillingPartyMember(member) : history.push('/billing_party/' + member.billing_party_id)}
                                            >
                                                <TableCell>{member.id}</TableCell>
                                                <TableCell>{(member.first_name + ' ' + member.last_name + ' (' + member.email + ')')}</TableCell>
                                                <TableCell>{member.group && member.group.tour && member.group.tour.internal_name}</TableCell>
                                                <TableCell>{member.group && member.group.name}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                {paginatorInfo && rowsPerPage && (
                    <CardActions className={classes.actions}>
                        <TablePagination
                            component="div"
                            count={paginatorInfo.total}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            page={paginatorInfo.currentPage - 1}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </CardActions>
                )}
            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
